import { Component, HostListener, OnInit } from '@angular/core';
import { TrackTrafficService } from 'src/app/services/track-traffic.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

featuredProperties = [
  {
    image: '/assets/images/rent.jpg',
    tag: 'FOR RENT',
    title: 'FOR RENT',
    location: 'Kuala Lumpur, Malaysia',
    price: 'Starting RM 1k/month'
  },
  {
    image: '/assets/images/sale.jpg',
    tag: 'FOR SALE',
    title: 'FOR SALE',
    location: 'Kuala Lumpur, Malaysia',
    price: 'Starting RM 200k'
  },
  {
    image: '/assets/images/commercial.jpg',
    tag: 'COMMERCIAL',
    title: 'COMMERCIAL',
    location: 'Kuala Lumpur, Malaysia',
    price: 'Shoplot|Office|Retail'
  },
  {
    image: '/assets/images/newProject.jpg',
    tag: 'NEW PROJECTS',
    title: 'NEW PROJECTS',
    location: 'Kuala Lumpur, Malaysia',
    price: 'Residential|Commercial| Rumah Mampu Milik'
  }
];

allPropertiesUrl = 'https://www.iproperty.com.my/property-agent/sw-ang-2967064/';

allTestimonials = [
  {
    image: 'assets/images/florence.jpg',
    name: 'Florence Leong',
    role: 'Tenant',
    location: 'Damansara',
    review: 'Very satisfied with the overall service and support provided by Ana. She was patient in understanding my requirements and suggested the right options. The entire process was handled smoothly with great attention to detail. Would definitely recommend Ana to anyone looking for a trustworthy property agent.',
    date: 'May 20, 2026',
    stars: [1,2,3,4,5],
    whatsapp: '+60122748467'
  },
      {
    image: 'assets/images/thomas.jpg',
    name: 'Ben Thomas',
    role: 'Tenant',
    location: 'Bangsar',
    review: 'Awesome experience from start to finish with a very professional approach. Ana was always available, quick to respond, and very easy to communicate with. She made the property search simple and stress-free with the right guidance. I would gladly work with her again in the future and highly recommend her services.',
    date: 'Feb 04, 2026',
    stars: [1,2,3,4,5],
    whatsapp: '+601163242054'
  },
    {
    image: '/assets/images/sara.jpeg',
    name: 'Sara Leong',
    role: 'Home Buyer',
    location: 'Kuala Lumpur',
    review: 'Excellent service! Professional, responsive, and very helpful throughout the entire process. Highly recommend! Ana guided me at every step and made the entire experience stress-free. All queries were answered quickly with clear and honest advice. Truly reliable and dedicated service that exceeded my expectations.',
    date: 'Jan 08, 2026',
    stars: [1,2,3,4,5],
    whatsapp: '+60172111332'
  },
    {
    image: 'assets/images/rent.jpg',
    name: 'Nur Amalia',
    role: 'Property Investor',
    location: 'Petaling Jaya',
    review: 'Very professional and highly responsive throughout the entire process. Ana showed properties that matched perfectly to my requirement. Communication was smooth, transparent, and always timely. Highly recommended for anyone looking to buy or sell property with confidence.',
    date: 'Dec 15, 2025',
    stars: [1,2,3,4,5],
    whatsapp: '+601172347680'
  }
  // Add more testimonials here...
];

  testimonials = this.allTestimonials.slice(0, 3);
  viewMoreTestimonials() {
    this.testimonials = this.allTestimonials;
  }

   constructor(
    private trackTrafficService: TrackTrafficService,
  ) {}

  ngOnInit(): void {
    this.checkReveal();
    // Call backend API in background to send email.
    this.trackTrafficService.trackTraffic()
      .subscribe({
        next: (response) => {
          console.log('Tracking success', response);
        },
        error: (error) => {
          console.error('Tracking failed', error);
        }
      });
  }
  
  @HostListener('window:scroll')
  onScroll() {
    this.checkReveal();
  }

  checkReveal() {
    const elements = document.querySelectorAll('.reveal');
    const windowHeight = window.innerHeight;
    elements.forEach((el: any) => {
      const position = el.getBoundingClientRect().top;

      if (position < windowHeight - 100) {
        el.classList.add('active');
      }
    });
  }
    scrollTo(element: HTMLElement) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
